import styled from "@emotion/styled";
import { FC, useCallback, useEffect, useState } from "react";
import { Bread } from "../../common/component/Bread";
import { ImageFill } from "../../common/component/ImageFill";
import { ImgCard } from "../../common/component/ImgCard";
import { NewsTypeEntity } from "../../module/news/entity/news.type.entity";
import newsTypeService from "../../module/news/service/news.type.service";

const breadArr = [
	{
		title: "新闻中心"
	}
]

export const Newsroom: FC = () => {
	const [data, setData] = useState<NewsTypeEntity[]>([]);

	const init = useCallback(async () => {
		const { data } = await newsTypeService.list();
		setData(data);
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
		init();
	}, [init]);

	
	return (
		<Container>
			<ImageFill src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/img/vhs-assets-css-192d10526151ca9492b8e98125d866c9.jpg"} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>新闻中心</h1>
				</div>
				<Bread value={breadArr} />
				<div>
					<h2>热情成就精度</h2>
					<div style={{textIndent: '1rem'}}>Arntz Optibelt 集团作为全球领先的高效传动皮带生产商之一，为世界各地的客户提供先进的传动解决方案。作为一家家族企业，Arntz Optibelt 通过提供行业特定产品的形式为各个行业提供一流的技术和品质。Optibelt 拥有超过 145 年的橡胶加工经验，专业生产各种传动皮带。
Optibelt 在 6 个国家设立了 8 个生产基地，销售办事处遍布全球，为集团的国际活动提供了成功的平台。
Arntz Optibelt 在全球五大洲拥有约 2100 名员工，确保一切生产活动和公司内部事务顺利运行。
Optibelt 持续提供超过 2.5 万种皮带，可在 24 小时内发货。</div>
				</div>
				<div className='list'>
					{data &&
						data.map((item, index) => {
							return (
								<div key={index} className="item col-lg-3 col-md-4 col-xs-12">
									<ImgCard title={item.title} description={item.newsDescription} img={item.image ?? ""} linkTitle={"查看详情"} url={`/news-type/${item.id}`} />
								</div>
							);
						})}
				</div>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.content {
		background: white;
		padding: 1em;
		z-index: 10;
		position: relative;

		.list {
			display: flex;
			margin: 0 -1rem;

			.item {
				padding: 1rem;
			}
		}
	}
`;
